import create from 'zustand'

export const useInsightsStore = create<any>(set => ({
  insight: null,
  setInsight: insight => set(state => ({ insight: insight })),
  removeInsight: () => set({ insight: null }),
}))
